import React, { useCallback, useEffect } from 'react';
import { Tappable } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import {
  COURSE_PAUSE_REQUEST_STATUSES,
  COURSE_PAUSE_RESCHEDULE_MODAL_STAGES,
  selectedRequestSelector,
  selectedSbatLectureSelector,
  setCoursePauseRescheduleModalStage,
  setSelectedRequest,
  setSelectedSbatLecture,
  setSelectedSuperBatch,
  useRescheduleRequestMutation,
} from 'features/courseResume';
import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import GlobalLoader from 'components/GlobalLoader';
import styles from './RescheduleResumeButton.module.scss';

function RescheduleResumeButton() {
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);
  const selectedSbatLecture = useSelector(selectedSbatLectureSelector);
  const [rescheduleResume, { isSuccess, error, isLoading: isUpdating }] =
    useRescheduleRequestMutation();

  const handleOnClick = useCallback(() => {
    rescheduleResume({
      requestId: selectedRequest.id,
      toSbatId: selectedSbatLecture?.id,
    });
  }, [rescheduleResume, selectedRequest.id, selectedSbatLecture?.id]);

  useEffect(() => {
    if (isSuccess) {
      batch(() => {
        dispatch(setSelectedSbatLecture(null));
        dispatch(setSelectedRequest(null));
        dispatch(setSelectedSuperBatch(null));
        dispatch(
          setCoursePauseRescheduleModalStage(
            COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.success
          )
        );
      });
      cogoToast.success('Successfully updated the request.');
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [dispatch, error]);

  if (
    selectedRequest.status === COURSE_PAUSE_REQUEST_STATUSES.scheduledResume
  ) {
    return (
      <>
        <GlobalLoader isVisible={isUpdating} />
        <Tappable
          onClick={handleOnClick}
          disabled={isUpdating || !selectedSbatLecture}
          className={classNames('btn btn-primary', styles.button)}
        >
          Reschedule Resume
        </Tappable>
      </>
    );
  }

  return null;
}

export default RescheduleResumeButton;
